/* CWC 22.10.2026 · Nachgeladene Bilder sanft einblenden (siehe cwc-smooth.css). */
(function(){
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  function prep(img){
    if(img.getAttribute('data-cwc-fade'))return;
    img.setAttribute('data-cwc-fade','1');
    if(img.getAttribute('fetchpriority')==='high')return;
    if(img.complete&&img.naturalWidth)return;
    img.classList.add('cwc-fade');
    var shown=false;
    function show(){if(shown)return;shown=true;img.classList.add('cwc-fade--in');}
    img.addEventListener('load',show);
    img.addEventListener('error',show);
    setTimeout(show,4000);
  }
  function run(){
    var imgs=document.querySelectorAll('img[loading="lazy"]');
    for(var i=0;i<imgs.length;i++)prep(imgs[i]);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
